import { usePage } from "@tecnobit-srl/router";
import { isEmpty } from "lodash-es";
import { useMemo } from "react";
//#region src/index.tsx
var useIsCurrentUrl = (url) => {
	const { route: { url: currentUrl } } = usePage();
	return useMemo(() => {
		return !isEmpty(url) && currentUrl === url;
	}, [currentUrl, url]);
};
//#endregion
export { useIsCurrentUrl };
